// Sidebar.js
import React from "react";
import { NavLink } from "react-router-dom";
import logo from "../assets/ZapMPLogo.png";
import dashboardIcon from "../assets/Home.svg";
import empIcon from "../assets/emp.svg";
import clockIcon from "../assets/clock-icon.svg";
import transferIcon from "../assets/transfer.svg";
import documentIcon from "../assets/document.svg";
import accountIcon from "../assets/icon.svg";

const Sidebar = () => {
  const sidebarMenu = [
    { name: "Dashboard", path: "/", icon: dashboardIcon },
    {
      name: "Manage Employee Profile",
      path: "/manage-employee",
      icon: empIcon,
    },
    { name: "Clock Time", path: "/clock-time", icon: clockIcon },
    { name: "Paystubs", path: "/paystubs", icon: transferIcon },
    { name: "Documents", path: "/documents", icon: documentIcon },
    { name: "Account", path: "/account", icon: accountIcon },
    // { name: 'Log Out', path: '/logout', icon: 'logout', isDanger: true },
  ];

  return (
    <div
      className="bg-white"
      style={{
        width: "270px",
        height: "100vh",
        overflowY: "auto",
        position: "sticky",
        top: "0px",
        minWidth: "190px",
      }}
    >
      <div className="py-4 ps-4">
        <img
          src={logo}
          alt="Logo"
          className="img-fluid"
          style={{ maxWidth: "150px" }}
        />
      </div>
      <ul style={{ padding: "12px 0px 12px 18px" }}>
        {sidebarMenu.map((item, idx) => (
          <NavLink
            key={idx}
            to={item.path}
            className="text-decoration-none d-flex align-items-center gap-2 py-3 "
            style={({ isActive }) => ({
              color: isActive ? "#E7730A" : "#5D5D5D",
              textDecoration: "none",
            })}
          >
            <img src={item.icon} alt="" style={{ width: "16px" }} />
            {item.name}
          </NavLink>
        ))}
      </ul>
    </div>
  );
};

export default Sidebar;
